import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useAuth } from '../contexts/SupabaseAuthContext';
import { comics } from '../data/comics';

const ALL_COMIC_IDS = comics.map((c) => c.id);

export function useEntitlements() {
  const { user, isMasterAccess } = useAuth();
  const [unlockedComicIds, setUnlockedComicIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setUnlockedComicIds([]);
      setLoading(false);
      return;
    }
    if (isMasterAccess) {
      // Master has every comic available, same as buying/redeeming each one.
      setUnlockedComicIds(ALL_COMIC_IDS);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('user_comics')
      .select('comic_id')
      .eq('user_id', user.id);
    if (!error && data) {
      setUnlockedComicIds(data.map((row) => row.comic_id));
    }
    setLoading(false);
  }, [user, isMasterAccess]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const isUnlocked = useCallback(
    (comicId) => unlockedComicIds.includes(Number(comicId)),
    [unlockedComicIds]
  );

  return {
    unlockedComicIds,
    loading,
    isUnlocked,
    refresh,
  };
}
